<template>
  <div class="food-manage">
    <div class="food-search tuolele-main-box">
      <div class="tuolele-main-search tuolele-main-search-item">
        <el-form :inline="true" :model="listQuery" class="fn-clear">
          <el-form-item label="学生姓名" class="fn-left">
            <el-input v-model="listQuery.sub_name" />
          </el-form-item>
          <el-form-item label="测评名称" class="fn-left">
            <el-input v-model="listQuery.train_name" />
          </el-form-item>
          <el-form-item label="选择时间" class="fn-left">
            <el-date-picker v-model="listQuery.time" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="changeTime" />
          </el-form-item>
          <el-form-item label="适用年级" class="fn-left">
            <Select key="10" :selected.sync="listQuery.grade_id" :data="gradeLists" clearable placeholder="请选择" />
          </el-form-item>
          <el-form-item label="适用科目" class="fn-left">
            <Select key="5" :selected.sync="listQuery.subject_id" :data="subjectLists" clearable placeholder="请选择" />
          </el-form-item>
          <el-form-item label="状态" class="fn-left">
            <Select key="5" :selected.sync="listQuery.status" :data="statusLists" clearable placeholder="请选择" />
          </el-form-item>
          <el-form-item label="" class="fn-left">
            <el-button type="primary" @click="fnGetCorrectHomeworkList">查询</el-button>
          </el-form-item>
          <!-- <el-form-item label="" class="fn-left">
            <el-button type="success" @click="fnAddPakcage()">添加</el-button>
          </el-form-item> -->
        </el-form>
      </div>
    </div>
    <div class="tuolele-main-box">
      <el-table :key="tableKey" :data="lists" border stripe>
        <el-table-column label="测评时间" prop="create_time" align="center" />
        <el-table-column label="学员信息" prop="sub_name" align="center" />
        <el-table-column label="测评名称" prop="train_name" align="center" />
        <el-table-column label="年级" prop="grade_name" align="center" />
        <el-table-column label="科目" prop="subject_name" align="center" />
        <el-table-column label="总分" prop="total_score" align="center" />
        <el-table-column label="得分" prop="score" align="center" />
        <el-table-column label="正确率" align="center">
          <template slot-scope="{row}">
            {{ row.accuracy }}%
          </template>
        </el-table-column>
        <el-table-column label="状态" prop="status_name" align="center" />
        <el-table-column label="反馈" align="center">
          <template slot-scope="{row}">
            <el-image v-if="row.back_img" style="width: 40px; height: 40px" :src="row.back_img" :preview-src-list="[row.back_img]" fit="fit" />
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="{row}">
            <el-button v-if="row.status == 3 || row.status == 2" type="text" @click="fnShowCorrect(row)">查看批改</el-button>
            <el-button v-if="row.status == 2" type="text" @click="fnUploadConfirmCorrect(row.evaluation_id)">填写反馈</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer pagination-footer" style="text-align: center;">
      <el-pagination layout="prev, pager, next, slot, jumper" :current-page.sync="listQuery.p" prev-text="上一页" next-text="下一页" :total="listQuery.total" :page-size="listQuery.limit" @current-change="fnGetCorrectHomeworkList" />
    </div>
    <el-dialog class="abow_dialog" top="50" title="添加反馈" :visible.sync="bShowUploadImage" width="70%">
      <UploadImg
        :photo.sync="postForm.back_img"
        :name="'back_img'"
        @updateImg="updatePhoto"
      />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="fnSubmitCorrect()">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog class="abow_dialog" width="420px" title="批改详情" :visible.sync="bShowCorrect">
      <iframe
        :src="correctUrl"
        frameborder="0"
        width="376"
        height="667"
      />
    </el-dialog>
  </div>

</template>
<script>

import Select from '@/components/Select'
import commondata from '@/utils/commondata'
import UploadImg from '@/components/toolbar/UploadImg.vue'
var moment = require('moment')

// import { validateRequire } from '@/utils/validate'

// import Tool from '@/assets/js/tool.js'

export default {
  name: 'TyyDoubleTestRecord',
  components: {
    Select,
    UploadImg
  },
  data() {
    return {
      lists: [],
      tableKey: 0,
      listQuery: {
        p: 1,
        limit: 20,
        sub_name: '',
        train_name: '',
        subject_id: '',
        grade_id: '',
        begin_time: '',
        end_time: '',
        total: 0,
        time: '',
        status: ''
      },
      postForm: {
        evaluation_id: '',
        back_img: ''
      },
      packageTypes: commondata.TYY_PACKAGE_TYPE,
      packageStatus: commondata.OPEN_STATUS,
      gradeLists: commondata.GRADE_LISTS,
      subjectLists: commondata.TYY_SUBJECT_LISTS,
      statusLists: [],
      bShowCorrect: false,
      currentLoading: '',
      bShowUploadImage: false,
      correctUrl: ''
    }
  },
  created() {
    this.listQuery.time = [moment(new Date()).subtract(1, 'months').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
    this.listQuery.begin_time = this.listQuery.time[0]
    this.listQuery.end_time = this.listQuery.time[1]
    this.fnGetCorrectHomeworkList()
  },
  methods: {
    fnGetCorrectHomeworkList: function() {
      this.bShowUploadImage = false
      this.$http.tyyGetCorrectHomeworkList(this.listQuery).then(res => {
        this.listQuery.total = parseInt(res.data.count)
        this.statusLists = res.data.status_info
        this.lists = res.data.list
      })
    },
    fnToLiveSetting(live_id) {
      this.$router.push({
        path: 'tiyouyouAddLive',
        query: { id: live_id }
      })
    },

    fnAddPakcage: function() {
      this.$router.push({
        path: 'tiyouyouAddLive'
      })
    },
    changeTime: function(val) {
      if (val != null) {
        this.listQuery.begin_time = val[0]
        this.listQuery.end_time = val[1]
      } else {
        this.listQuery.begin_time = ''
        this.listQuery.end_time = ''
        this.listQuery.time = []
      }
    },
    fnUploadConfirmCorrect(evaluation_id) {
      this.postForm.evaluation_id = evaluation_id
      this.bShowUploadImage = true
    },
    updatePhoto: function(photo, name) {
      this.postForm.back_img = photo
    },
    fnSubmitCorrect: function() {
      if (this.postForm.back_img == '') {
        this.$message.error('请上传图片')
        return
      }
      this.$http.tyyFinishCorrect(this.postForm).then(res => {
        if (res.code == 200) {
          this.postForm.back_img = ''
          this.$message.success('提交成功')
          this.fnGetCorrectHomeworkList()
        }
      })
    },
    fnShowCorrect: function(homework) {
      const url = process.env.VUE_APP_TUOLELE_URL
      this.correctUrl = `${url}api.php/correct/homeworkResult?homework_list_id=${homework.homework_list_id}&sub=${homework.sub_id}`
      this.bShowCorrect = true
    }
  }
}
</script>
<style lang="scss">
  .food-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .split-time{
      margin-right: 20px;
    }
    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
</style>
